const fakeData = [
    {id:1,name:"Animal Shelter",img:"https://i.postimg.cc/V66dsJSn/animal-Shelter.png"},
    {id:2,name:"Baby Sit",img:"https://i.postimg.cc/rFYgq4KC/babySit.png"},
    {id:3,name:"Bird House",img:"https://i.postimg.cc/prLYHVv6/bird-House.png"},
    {id:4,name:"child Support",img:"https://i.postimg.cc/SxBrMpLn/child-Support.png"},
    {id:5,name:"Clean Water",img:"https://i.postimg.cc/T3L01Pb8/clean-Water.png"},
    {id:6,name:"Clean Park",img:"https://i.postimg.cc/sxGxSb42/clearn-Park.png"},
    {id:7,name:"Cloth Swap",img:"https://i.postimg.cc/wBDk5bF0/cloth-Swap.png"},
    {id:8,name:"Drive Safety",img:"https://i.postimg.cc/J4TYtgdX/drive-Safety.png"},
    {id:10,name:"Food Charity",img:"https://i.postimg.cc/jS4HLJjF/food-Charity.png"},
    {id:11,name:"Good Education",img:"https://i.postimg.cc/jjqzNdwd/good-Education.png"},
    {id:12,name:"IT Help",img:"https://i.postimg.cc/T36jdcTb/ITHelp.png"},
    {id:13,name:"Library Books",img:"https://i.postimg.cc/jqnyy15N/library-Books.png"},
    {id:14,name:"Music Lessons",img:"https://i.postimg.cc/tTwPL3rY/music-Lessons.png"},
    {id:15,name:"New Books",img:"https://i.postimg.cc/Xq5F3rhx/newBooks.png"},
    {id:16,name:"Refuse Shelter",img:"https://i.postimg.cc/Twpg77Jz/refuse-Shelter.png"},
    {id:17,name:"River Clean",img:"https://i.postimg.cc/bNXkgRD5/river-Clean.png"},
    {id:18,name:"School Suffiles",img:"https://i.postimg.cc/284vKBnS/school-Suffiles.png"},
    {id:19,name:"Study Group",img:"https://i.postimg.cc/jStN0dhQ/study-Group.png"},
    {id:20,name:"Stuffed Animals",img:"https://i.postimg.cc/jScfs0gV/stuffed-Animals.png"},
    {id:21,name:"Vote Register",img:"https://i.postimg.cc/W44kzWCd/vote-Register.png"},
];
export default fakeData;
